import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import AppLinkRedirect from "../components/AppLinkRedirect";
import {
  buildDeepLink,
  decodeAndValidateProfileHandle
} from "../utils/appLinks";

function SocialProfileRedirect() {
  const { handle: routeHandle = "" } = useParams();
  const handle = decodeAndValidateProfileHandle(routeHandle);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = "View a profile on Mondoway | Mondoway";

    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <AppLinkRedirect
      deepLinkUrl={handle ? buildDeepLink("profile", handle) : null}
      invalid={!handle}
      openingTitle="Opening this profile in Mondoway..."
      invalidTitle="This profile link is invalid."
    />
  );
}

export default SocialProfileRedirect;
